import { render, staticRenderFns } from "./DsfrHighlight.vue?vue&type=template&id=72bed334&scoped=true&"
import script from "./DsfrHighlight.vue?vue&type=script&lang=js&"
export * from "./DsfrHighlight.vue?vue&type=script&lang=js&"
import style0 from "./DsfrHighlight.vue?vue&type=style&index=0&id=72bed334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bed334",
  null
  
)

export default component.exports